import {
  ALPHA_NUMERIC_WITH_SPACE_HYPHEN,
  OnboardConstants,
  PlaceHolderText,
  StaffListConstants,
} from "../../constants/constants";
import { formatDate, formatDateInput } from "../../utils/DataTime";
import Button from "./cta/Button";
import Input from "./cta/Input";
import {
  staffVerificationCancelButton,
  staffVerificationverifiedButton,
  staffVerificationverifyButton,
} from "./styles/CommonStyles";
import { TextFeild } from "./TextFeild";
import { getMaxDateForDateofBirth } from "./UserResgistrationInitialPayload";

export const DLVerificationDetail = ({
  userInfo,
  handleChange,
  isDetailPresent,
  handleVerifyButtonChange,
  verifyTitle,
  handelCancelButton,
  showVerifyButton,
}: any) => {
  return (
    <>
      {isDetailPresent ? (
        <div className="pl-6 md:pl-8 pt-10  grid md:grid-rows-1 md:grid-flow-col gap-5 pr-6 md:pr-8 md:pr-[292px]">
          <TextFeild
            textFeildName={StaffListConstants.DrivingLicence}
            placeholder={
              userInfo?.professionalDetails?.drivingLicenceNumber ?? ""
            }
          />
          <TextFeild
            textFeildName={OnboardConstants.DateOfBirth}
            placeholder={formatDate(userInfo?.dateOfBirth ?? "2023/02/04")}
          />
        </div>
      ) : (
        <div className="flex flex-col md:flex-row md:gap-2 px-6 md:px-0 md:pl-8">
         <div className="w-full md:w-1/2 relative">
            <Input
              type="text"
              name="drivingLicenceNumber"
              value={userInfo?.professionalDetails?.drivingLicenceNumber}
              placeholder={PlaceHolderText.drivingLicenseNumber}
              handleOnChange={handleChange}
              label={StaffListConstants.DrivingLicence}
              regexCode={ALPHA_NUMERIC_WITH_SPACE_HYPHEN}
            />
          </div>
          <div className="w-full md:w-1/2 relative">
            <Input
              type="date"
              value={
                userInfo?.dateOfBirth
                  ? formatDateInput(userInfo?.dateOfBirth)
                  : ""
              }
              name="dateOfBirth"
              handleOnChange={handleChange}
              placeholder={"DateOfBirth"}
              label={OnboardConstants.DateOfBirth}
              max={getMaxDateForDateofBirth()}
              onKeyDown={(e: any) => {
                e.preventDefault();
              }}
              isDateOfBirth={true}
            />
          </div>
        </div>
      )}
      <div className="md:pl-8">
        <div className="flex justify-center md:justify-start items-center md:items-start">
          {!userInfo?.ekycStatus?.drivingLicense && (
            <div className="mb-6">
              <Button
                handleClick={handelCancelButton}
                buttonText={StaffListConstants.Cancel}
                className={staffVerificationCancelButton}
              />

              <Button
                handleClick={
                  showVerifyButton && !userInfo?.ekycStatus?.drivingLicense
                    ? () => handleVerifyButtonChange(verifyTitle)
                    : () => {}
                }
                buttonText={
                  !userInfo?.ekycStatus?.drivingLicense
                    ? OnboardConstants.verify
                    : OnboardConstants.verified
                }
                className={
                  !userInfo?.ekycStatus?.drivingLicense
                    ? staffVerificationverifyButton
                    : staffVerificationverifiedButton
                }
              />
            </div>
          )}
        </div>
      </div>
    </>
  );
};
